"use client";

import React from "react";
var __jsx = React.createElement;
import FooterLinks from "../components/links";
import FooterCopyrightMessage from "../components/copyright";
import { useTranslations } from "next-intl";
import { seeClaimsBook } from "@lib/util/link-redirection-ops";
import MaxWidthContainer from "@modules/layout/components/shared/muscle-max-width";
import useTrackEvent from "@lib/hooks/use-track-event";
import { MIXPANEL_EVENTS } from "@lib/mixpanel/mixpanel.event-list";
import FooterConfigButtons from "../../footer-default/components/config-buttons";
import Icons from "@modules/icons";
import { BancogralFooterLogo } from "../components/logos";
import useCssModules from "@lib/hooks/use-css-modules";
const WebFooter = _ref => {
  var _cssModules$footers$f;
  let {} = _ref;
  const t = useTranslations();
  const trackEvent = useTrackEvent();
  const {
    cssModules
  } = useCssModules();
  const {
    containerClassNames,
    entityLogoContainerClassNames,
    entityLogoClassNames,
    linksContainerClassNames,
    privacyPolicyClassNames,
    termsAndConditionsClassNames,
    phoneNumberClassNames,
    phoneNumberIconClassNames,
    emailClassNames,
    emailIconClassNames,
    copyRightClassNames,
    allRightsReservedClassNames,
    entityTextClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerBancogral) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx(MaxWidthContainer, null, __jsx("div", null, __jsx("div", null, __jsx("div", {
    className: entityLogoClassNames
  }, __jsx(BancogralFooterLogo, {
    className: entityLogoClassNames
  })), __jsx(FooterLinks, null), __jsx(FooterCopyrightMessage, null)), process.env.NEXT_PUBLIC_CLAIMS_BOOK_URL ? __jsx("div", {
    className: "flex flex-col items-center gap-4"
  }, __jsx(FooterConfigButtons, null), __jsx("div", {
    className: "flex gap-2 items-center"
  }, __jsx("div", null, __jsx(Icons.book, {
    size: 23
  })), __jsx("div", {
    onClick: () => {
      seeClaimsBook();
      trackEvent(MIXPANEL_EVENTS.Home.CLAIMS_OPEN_BOOK);
    },
    className: "cursor-pointer text-sm text-white font-bold"
  }, t("Shared.Layout.CLAIMS_BOOK")))) : null));
};
export default WebFooter;